import "core-js/modules/es.array.push.js";
export default {
  props: ["result"],
  methods: {
    returnRouter(index, item) {
      if (index == 1) {
        // 获取扁平化后的菜单数组
        let routerListFlat = JSON.parse(localStorage.getItem("routerListFlat") || []);

        //获取当前菜单的唯一id  例如2-3-1
        let path = routerListFlat.filter(n => n.routerName == item)[0].path;
        this.$router.push(path);
      }
    }
  }
};